// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InviteMembersForm_actions__IKMYj {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 auto;
  background: #fff;
  padding-top: 24px;
}

.InviteMembersForm_formGroup__Geu\\+m {
  margin-top: 16px;
  width: 100%;
}
.InviteMembersForm_formGroup_checkbox__a4WtK {
  margin-top: 4.5px;
}

.InviteMembersForm_formBlock__kSiOE {
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/companies/Form/InviteMembersForm/InviteMembersForm.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;AACF;AACE;EACE,iBAAA;AACJ;;AAGA;EACE,mBAAA;AAAF","sourcesContent":[".actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex: 0 0 auto;\n  background: #fff;\n  padding-top: 24px;\n}\n\n.formGroup {\n  margin-top: 16px;\n  width: 100%;\n\n  &_checkbox {\n    margin-top: 4.5px;\n  }\n}\n\n.formBlock {\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `InviteMembersForm_actions__IKMYj`,
	"formGroup": `InviteMembersForm_formGroup__Geu+m`,
	"formGroup_checkbox": `InviteMembersForm_formGroup_checkbox__a4WtK`,
	"formBlock": `InviteMembersForm_formBlock__kSiOE`
};
export default ___CSS_LOADER_EXPORT___;
